import React from 'react';
import { create } from 'zustand';

export interface DialogState {
  isDialogOpen: boolean;
  dialogContent: React.ReactNode;
  openDialog: (options: DialogOptions) => void;
  closeDialog: () => void;
  requiredInteraction: boolean;
}

interface DialogOptions {
  dialogContent: React.ReactNode;
  requiredInteraction?: boolean;
}

/**
 * Represents the state and actions related to a dialog.
 */
export const useDialogStore = create<DialogState>((set) => ({
  /**
   * Indicates whether the dialog is currently open or not.
   */
  isDialogOpen: false,

  /**
   * The content of the dialog.
   */
  dialogContent: null,

  /**
   * Indicates whether the dialog requires user interaction or not.
   */
  requiredInteraction: false,

  /**
   * Opens the dialog with the specified options.
   * @param {DialogOptions} options - The options for the dialog.
   */
  openDialog: (options: DialogOptions) =>
    set({ isDialogOpen: true, ...options }),

  /**
   * Closes the dialog.
   */
  closeDialog: () => set({ isDialogOpen: false }),
}));
